import { GridCellParams, type GridEventListener } from '@/components/custom/erp';
import { useWatch } from 'react-hook-form';
import React from 'react';
import { SelectedCellInfo } from '../hooks/useDetailRows';
import { InputTable } from '@/components/custom/erp';
import { getDetailTableColumns } from './columns';
import { FormMode } from '@/types/form';
import ActionBar from './ActionBar';

interface DetailTabProps {
  formMode: FormMode;
  rows: { uuid?: string | null }[];
  selectedRowUuid?: string | null;
  selectedCell?: SelectedCellInfo | null;
  onRowClick?: GridEventListener<'rowClick'>;
  onCellClick?: (params: GridCellParams) => void;
  onExport: () => void;
  onPin: () => void;
}

export const DetailTab: React.FC<DetailTabProps> = ({
  formMode,
  rows,
  selectedRowUuid,
  onRowClick,
  onExport,
  onPin
}) => {
  const [ma_ngv] = useWatch({ name: ['ma_ngv'] });

  return (
    <InputTable
      rows={rows}
      onRowClick={onRowClick}
      selectedRowId={selectedRowUuid || undefined}
      columns={getDetailTableColumns(ma_ngv)}
      getRowId={row => row?.uuid || ''}
      actionButtons={<ActionBar formMode={formMode} handleExport={onExport} handlePin={onPin} />}
    />
  );
};
